import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

interface EnvVarsSectionProps {
  envVars: Array<{ key: string; value: string }>;
  showEnvVars: boolean;
  onToggle: () => void;
  onAdd: () => void;
  onRemove: (index: number) => void;
  onUpdate: (index: number, field: "key" | "value", value: string) => void;
}

export function EnvVarsSection({
  envVars,
  showEnvVars,
  onToggle,
  onAdd,
  onRemove,
  onUpdate,
}: EnvVarsSectionProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">
            Environment Variables
          </span>
          {envVars.length > 0 && (
            <span className="text-xs text-muted-foreground">
              ({envVars.length})
            </span>
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAdd}
          className="text-xs"
        >
          Add Variable
        </Button>
      </div>

      <p className="text-xs text-muted-foreground">
        Environment variables for your MCP server process (e.g. API keys, config
        values)
      </p>

      {envVars.length > 0 ? (
        <div className="space-y-2 max-h-48 overflow-y-auto">
          {envVars.map((envVar, index) => (
            <div
              key={index}
              className="flex gap-2 items-center p-3 bg-muted/30 rounded-lg border border-border"
            >
              <Input
                placeholder="VARIABLE_NAME"
                value={envVar.key}
                onChange={(e) => onUpdate(index, "key", e.target.value)}
                className="h-8 text-xs flex-1"
              />
              <Input
                placeholder="value"
                value={envVar.value}
                onChange={(e) => onUpdate(index, "value", e.target.value)}
                className="h-8 text-xs flex-1"
              />
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemove(index)}
                className="h-8 w-8 p-0 text-muted-foreground hover:text-destructive flex-shrink-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div className="border border-dashed border-border rounded-lg p-6 text-center bg-muted/20">
          <p className="text-sm text-muted-foreground">
            No environment variables configured
          </p>
        </div>
      )}
    </div>
  );
}
